import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthService} from '@services/auth.service';
import {Router} from '@angular/router';
import {HttpService} from '@services/http.service';
import {environment} from '@env/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
    router = inject(Router);
    http = inject(HttpService);
    constructor(public authService: AuthService) {
  }

  loginRedirect(): void {
    this.authService.loginRedirect();
    /*const currentOrigin = environment.api.BE || window.location.origin;
    window.location.href = `${currentOrigin}/web/login?redirect=${encodeURIComponent(window.location.origin)}`;*/
  }

  ngOnInit(): void {
   if (this.authService.isLoggedIn()) {
     this.router.navigate(['/']).then();
   }
  }
}
